import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 10,
    },
    loadmore: {
      color: "#6B46E5",
      fontSize: 30,
      paddingTop: 20,
      paddingBottom: 20,
    },
    textCenter: {
      textAlign: "center",
    },
    noText: {
      fontSize: 14,
      color: "gray",
      paddingTop: 140,
      textAlign: "center",
      paddingLeft: 6,
      paddingRight: 6,
      width: "100%",
      "& a": {
        fontSize: 14,
        color: "gray",
      },
    },
    filterContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 20px",
      height: 44,
      width: "100%",
      backgroundColor: "#E0E0E0",
      maxWidth: 1024,
      margin: "0 auto",
      [theme.breakpoints.down("sm")]: {
        padding: "8px 10px",
        height: "auto",
        minHeight: 44,
        flexWrap: "wrap",
      },
    },
    filterMenuItem: {
      "&.Mui-selected": {
        backgroundColor: "#6B46E5",
        color: "white",
        "&:hover": {
          backgroundColor: "#6B46E5",
        },
      },
    },
    filterButton: {
      color: "#000000",
      textTransform: "none",
      fontWeight: "bold",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
        padding: "4px 8px",
        minWidth: "auto",
        maxWidth: "130px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    filterButtonActive: {
      backgroundColor: "#6B46E5",
      color: "white",
      "&:hover": {
        backgroundColor: "#6B46E5",
      },
    },
    filterClearWrapper: {
      display: "inline-flex",
      alignItems: "center",
    },
    filterClearIcon: {
      marginLeft: 4,
      padding: 4,
      color: "inherit",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.2)",
      },
    },
    sortButton: {
      color: "#000000",
      textTransform: "none",
      fontWeight: "bold",
      marginLeft: "auto",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
        padding: "4px 8px",
        minWidth: "auto",
      },
    },
  })
);

export default useStyles;
